<template lang="html">
  <div class="list">
    <div class="list-privilege">

    </div>
    <div class="list-wrapper" v-for="(item, index) in courseList" :key="item.id">
      <mine-item :course="item" :courseIndex="index" @showNotice="showNotice"/>
    </div>
    <notice ref="notice" :closeBtn="true">
      <div class="mine-coursewave">
        <p>复制链接：</p>
        <p>{{downLoadUrl}}</p>
        <p>在电脑端浏览器打开即可进行下载哦~</p>
      </div>
    </notice>
  </div>
</template>

<script>
import MineItem from "../Mine/Item.vue";
import Notice from '../Notice.vue'
export default {
  name: 'List',
  data() {
    return {
      downLoadUrl: ''
    }
  },
  props: {
    courseList: {
      type: Array,
      default: []
    }
  },
  methods: {
    showNotice(url) {
      this.downLoadUrl = url
      this.$refs.notice.show()
    }
  },
  components: {
    MineItem,
    Notice
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.list {
  margin-bottom: rem(60);
  .mine-coursewave {
    padding: use(50) use(50) use(90);
    p{
      font-size: use(27);
      color: #666666;
      text-align: center;
      line-height: use(60);
    }
    p:nth-child(2){
      color: #39A1FF;
      font-size: use(30);
      word-break: break-all;
    }
  }
}
</style>
